import { v4 as uuidv4 } from "uuid";

import { LoanAccount, PrimaryParty, AccountRelations } from "../../../api/creditAccounts";

// --- Empty-row factories for the Party-Involved (V5 / Credit) draft ---
export const buildEmptyLoanAccount = (): LoanAccount => ({
  accountNumber: uuidv4(),
  extAccountNumber: "",
  product: "",
  creditFacility: "",
  accountName: "",
});

export const buildEmptyAccountRelations = (): AccountRelations => ({
  id: uuidv4(),
  related_as: undefined,
  account_numbers: [],
});

export const buildEmptyParty = (): PrimaryParty => ({
  id: uuidv4(),
  name: "",
  account_relationships: [buildEmptyAccountRelations()],
});
